import Markdown from "react-markdown";
import useCreateNotes from "zustand-store/create-notes";

const RegeneratedNotes = ({
  prevNotes,
  templateId,
  regeneratedNotes,
  setNoteChangesInput,
  setRegeneratedNotes,
  setChangesMade,
  setIsNotesAutoSaving,
  handleSaveSession
}) => {
  const { setGeneratedNotes, generatedNotes } = useCreateNotes();

  const getNewlyGeneratedNotesData = async () => {
    const tempGeneratedNotes = [...generatedNotes];
    const index = tempGeneratedNotes.findIndex(
      (el) => parseInt(el.templateId) === parseInt(templateId)
    );
    if (index < 0) return generatedNotes;
    const outputObj = tempGeneratedNotes[index];
    outputObj.output = regeneratedNotes;
    tempGeneratedNotes[index] = { ...tempGeneratedNotes[index], outputObj };
    setGeneratedNotes([...tempGeneratedNotes]);
    setNoteChangesInput("");
    setChangesMade(true);
    setRegeneratedNotes(null); // close the modal

    setIsNotesAutoSaving(true);
    await handleSaveSession();
    setIsNotesAutoSaving(false);
  };

  return (
    <>
      <div className="min-h-[450px] max-h-[450px] w-full mb-4 overflow-y-auto">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <h1 className="mb-4 text-xl font-bold">Previous Version</h1>
            <Markdown className="text-xl text-justify">{prevNotes}</Markdown>
          </div>
          <div>
            <h1 className="mb-4 text-xl font-bold">Regenerated Version</h1>
            <Markdown className="text-xl text-justify">
              {regeneratedNotes}
            </Markdown>
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full">
        <div className="flex items-center gap-4">
          <button
            onClick={() => setRegeneratedNotes(null)}
            className="px-[10px] py-2 rounded-ns-tile bg-shade-50 text-xl flex items-center"
          >
            Cancel
          </button>

          <button
            onClick={() => getNewlyGeneratedNotesData()}
            className="px-[10px] py-2 rounded-ns-tile bg-danger/10 text-xl flex items-center"
          >
            Update
          </button>
        </div>
      </div>
    </>
  );
};

export default RegeneratedNotes;
